import { PageHero } from '../components/ui/PageHero.jsx';
import { Section, Wrap, Grid } from '../components/ui/Section.jsx';
import { Eyebrow } from '../components/ui/Eyebrow.jsx';
import { Button } from '../components/ui/Button.jsx';
import styles from './ProjectsPage.module.css';
import { Reveal } from '../components/ui/motion.jsx';
import { ProjectCard } from '../components/ui/ProjectCard.jsx';
import { projects } from '../data/projects.js';

export const meta = {
  title: 'Projects — Abode Custom Homes',
  description:
    'Custom homes by Abode Custom Homes in Bloomington-Normal and McLean County, Illinois. A young studio — this gallery grows with every home we break ground on.',
};

export default function ProjectsPage() {
  const [lead, ...rest] = projects;

  return (
    <>
      <PageHero
        eyebrow="Our Work"
        lines={['Homes shaped around', 'the families who live in them.']}
        lede="Abode is a young studio — this gallery will grow with every home we break ground on in Bloomington and McLean County. Here's where we're starting."
      />

      <Section>
        <Wrap>
          <Reveal style={{ marginBottom: 'var(--space-4)' }}>
            <ProjectCard project={lead} wide />
          </Reveal>

          {/* Three across once there are three to show. Below that, the
              invitation takes the remaining column, so a short list reads
              as deliberate rather than as a grid with holes in it. */}
          <Grid cols={rest.length >= 3 ? 3 : 2}>
            {rest.map((project) => (
              <Reveal key={project.slug}>
                <ProjectCard project={project} />
              </Reveal>
            ))}

            {rest.length < 3 ? (
              <Reveal className={styles.invitation}>
                <Eyebrow animated={false}>Your Project</Eyebrow>
                <h2 className="h3 mt-2">Have a lot in mind?</h2>
                <p className="mt-2">
                  We&rsquo;d love to add your home to this list. Tell us about the lot, the
                  timeline, or just the idea — whichever stage you&rsquo;re at.
                </p>
                <Button to="/contact" variant="ghost" className="mt-4">
                  Start a conversation
                </Button>
              </Reveal>
            ) : null}
          </Grid>
        </Wrap>
      </Section>
    </>
  );
}
